import { Footer } from "@/components/LandingPage/Footer";
import { GetStarted } from "@/components/LandingPage/GetStarted";
import Navbar from "@/components/LandingPage/Navbar";
import { useViewport } from "@/hooks/useViewport";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react";
import heroBg from "@root/public/images/photos/clarifayo_ninho.png";
import { GetServerSideProps } from "next";
import { useTranslations } from "next-intl";
import Head from "next/head";
import Image from "next/image";
type Faq = {
  question: string;
  answer: string;
};

const Hero = () => {
  const t = useTranslations("faq");
  const { isMobile } = useViewport();

  const mainFaq: Faq[] = [
    {
      question: t("question1"),
      answer: t("answer1"),
    },
    {
      question: t("question2"),
      answer: t("answer2"),
    },
    {
      question: t("question3"),
      answer: t("answer3"),
    },
  ];
  return (
    <Stack
      gap={{ base: 8, md: 14 }}
      py={{ base: 32, md: 20 }}
      px={{
        base: 8,
        md: 20,
      }}
      bgColor="brand.1000"
      minH={{
        base: "90vh",
        md: "90vh",
      }}
      position="relative"
    >
      <Box className="pricing-hero-bg">
        {isMobile ? (
          <Image
            src={heroBg}
            alt="hero background"
            width={4352 / 4}
            height={2901 / 4}
            quality={80}
            objectFit="cover"
            loading="eager"
            style={{
              position: "absolute",
              objectFit: "cover",
              left: 0,
              top: 0,
              height: "100%",
              zIndex: 0,
            }}
          />
        ) : (
          <Image
            src={heroBg}
            alt="hero background"
            width={4352 / 4}
            height={2901 / 4}
            quality={80}
            objectFit="cover"
            loading="eager"
            style={{
              position: "absolute",
              aspectRatio: "16/9",
              left: 0,
              top: 0,
              maxWidth: "100%",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          />
        )}
      </Box>
      <Box position="absolute" top={0} left={0} w="full">
        <Navbar />
      </Box>
      <Stack
        as={Box}
        direction={["column", "row"]}
        textAlign={"left"}
        alignItems="center"
        flex={1}
        gap={{
          base: 8,
          md: 4,
        }}
        position="relative"
        h="full"
      >
        <Box flex={2}>
          <Heading
            letterSpacing={"0.2rem"}
            color="brand.100"
            fontFamily={"Marlide"}
            lineHeight={"110%"}
            textAlign={{ base: "center", md: "left" }}
          >
            FAQ
          </Heading>
          <Text color={"brand.900"} mt={6} fontSize="lg">
            Frequently Asked Questions
          </Text>
        </Box>
        <Box flex={3} pt={6}>
          <Accordion allowToggle>
            {mainFaq.map((faq, index) => (
              <AccordionItem
                key={faq.question}
                bgColor={"rgba(0,0,0,.6)"}
                color="white"
                px={1}
                py={2}
                borderRadius="12px"
                mb={4}
                borderTopWidth="none"
                _last={{
                  borderBottomWidth: "none",
                }}
              >
                <h2>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      fontSize="18px"
                      textAlign="left"
                      fontWeight={600}
                    >
                      {faq.question}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel
                  pb={4}
                  dangerouslySetInnerHTML={{
                    __html: faq.answer,
                  }}
                ></AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </Stack>
    </Stack>
  );
};

const AllQuestions = () => {
  const t = useTranslations("faq");
  const faq: Faq[] = [
    {
      question: t("question5"),
      answer: t("answer5"),
    },
    {
      question: t("question6"),
      answer: t("answer6"),
    },
    {
      question: t("question7"),
      answer: t("answer7"),
    },
    {
      question: t("question8"),
      answer: t("answer8"),
    },
    {
      question: t("question9"),
      answer: t("answer9"),
    },

    {
      question: t("question10"),
      answer: t("answer10"),
    },
    {
      question: t("question11"),
      answer: t("answer11"),
    },
    {
      question: t("question12"),
      answer: t("answer12"),
    },
    {
      question: t("question13"),
      answer: t("answer13"),
    },
    {
      question: t("question14"),
      answer: t("answer14"),
    },
    {
      question: t("question15"),
      answer: t("answer15"),
    },
  ];
  return (
    <Stack
      py={{ base: 20, md: 20 }}
      px={{
        base: 8,
        md: 20,
      }}
      bgColor="brand.100"
    >
      <Container maxW="container.lg">
        <Heading
          color="brand.1000"
          fontSize="48px"
          fontWeight={600}
          textAlign="center"
          mb={12}
        >
          {t("allQuestions")}
        </Heading>
        <Accordion allowToggle>
          {faq.map((faq, index) => (
            <AccordionItem
              key={faq.question}
              bgColor={"brand.1000"}
              color="brand.900"
              px={1}
              py={2}
              borderRadius="12px"
              mb={4}
              borderTopWidth="none"
              _last={{
                borderBottomWidth: "none",
              }}
            >
              <h2>
                <AccordionButton>
                  <Box
                    as="span"
                    flex="1"
                    fontSize="18px"
                    textAlign="left"
                    fontWeight={600}
                  >
                    {faq.question}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} color="brand.100">
                {faq.answer}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Stack>
  );
};

export default function Page() {
  return (
    <>
      <Head>
        <title>Clarifayo - maximize your Coaching Activity</title>
      </Head>
      <Box bgColor="brand.100" className="landing-page">
        <Hero />
        <AllQuestions />
        <GetStarted />
        <Footer />
      </Box>
    </>
  );
}

export const getStaticProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};
